import React from 'react';

import { StyleSheet } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import { Box, BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';

export const ProductInformationContainer = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Box
      accessible
      focusable
      {...props}
      style={[
        styles.productInformationContainer,
        isDesktop && styles.productInformationContainerDesktop,
        style,
      ]}
    />
  );
};

export const ProductInformationTitle = withTypography({
  variant: 'headerFour',
  fontSize: 16,
  my: '$4',
});

const styles = StyleSheet.create({
  productInformationContainer: {
    marginTop: 16,
    paddingHorizontal: 16,
  },
  productInformationContainerDesktop: {
    marginTop: 32,
    paddingHorizontal: 0,
  },
});
